import { Trans, useTranslation } from 'react-i18next';
import bgBackToSignUp from 'src/assets/images/registration/bgBackToSignUpModal.webp';
import characterBackToSignUp from 'src/assets/images/registration/characterBackToSignUpModal.webp';
import { Button } from 'src/components/Buttons/Button';
import { ModalWrapper } from 'src/components/ModalWrapper';
import { useAuthFlow } from 'src/modules/authFlow/hooks/useAuthFlow';

const BackToSignupModal = () => {
  const { t } = useTranslation();
  const { startRegistration } = useAuthFlow();

  return (
    <ModalWrapper
      isTransparentBg
      containerClassName="768:overflow-visible"
      className="768:overflow-visible">
      <div
        className="rounded-[20px] h-[483px] relative overflow-visible p-[15px] 768:w-[690px] 768:h-[320px]"
        style={{
          backgroundImage: `url(${bgBackToSignUp})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'top center'
        }}>
        <div className="absolute 768:top-[-35px] bottom-0 768:left-[0px] w-[180px] left-[22%] 568:w-[205px] 768:w-[275px] z-[100]">
          <img src={characterBackToSignUp} alt="back to sign up modal character" />
        </div>

        <div className="font-bold text-center 768:float-right 768:h-full 768:mt-[15px] 768:w-[395px] relative">
          <p className="text-btsm_title text-2xl mb-[8px] uppercase 768:text-[30px]">
            {t('backToSignUpModal.title')}
          </p>
          <p className="text-btsm_text text-lg 768:text-[20px] mt-[30px]">
            <Trans
              i18nKey="backToSignUpModal.description"
              components={{
                1: <span className="text-btsm_time" />
              }}
            />
          </p>
          <Button
            onClick={() => {
              startRegistration({ replace: true });
            }}
            mode="button-primary"
            className="px-6 max-w-full normal-case mt-[35px] 768:mt-[70px]"
            title="Back to registration">
            {t('backToSignUpModal.button')}
          </Button>
        </div>
      </div>
    </ModalWrapper>
  );
};

// eslint-disable-next-line no-restricted-exports
export default BackToSignupModal;
